import * as XLSX from "xlsx";

export const processExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      try {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Get full header row manually
        const headerRow = XLSX.utils.sheet_to_json(worksheet, {
          header: 1, // returns 2D array: [ [header1, header2, ...], [...], ... ]
        })[0]; // Get first row (headers)

        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        // Normalize data: Ensure each row has all headers, missing values set to null
        const normalizedData = jsonData.map((row) => {
          const normalizedRow = {};
          headerRow.forEach((key) => {
            normalizedRow[key] = row[key] !== undefined ? row[key] : null;
          });
          return normalizedRow;
        });

        resolve(normalizedData);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
  });
};
